<!--
This component is a little special.
Instead of <template> it uses a render function.

HOW ABOUT THAT?!

In short, it:
    - imports the Base Case-View Layout, along with the data related to the case/url that should be viewed.
    - imports all the components that can be used on the Case-View, to be able to spit these out later. With data.
    - loops through the render function, that first renders the base layout and then continues to loop the pageContent-array

NOTE: The data(), computed, and watch can surely be refactored to be more readable. It works now, and it easily breaks if you mixture with it. When going straight from case to case. Handle with care.

-->

<script>
import {
    mapState
} from 'vuex'
import CaseViewBaseLayout from '@/components/CaseViewBaseLayout.vue'
import CaseViewDoubleWithoutMargin from '@/components/CaseViewDoubleWithoutMargin.vue'
import CaseViewDoubleWithMargin from '@/components/CaseViewDoubleWithMargin.vue'
import CaseViewSingleImage from '@/components/CaseViewSingleImage.vue'
import CaseViewTrippleImage from '@/components/CaseViewTrippleImage.vue'
import CaseViewSingleVideo from '@/components/CaseViewSingleVideo.vue'
import CaseViewDuoOffsetImage from '@/components/CaseViewDuoOffsetImage.vue'
import CaseViewLargeText from '@/components/CaseViewLargeText.vue'
import CaseViewTestimony from '@/components/CaseViewTestimony.vue'
import CaseViewColors from '@/components/CaseViewColors.vue'
import SvgImage from '@/components/SvgImage.vue'
import SvgAnimated from '@/components/SvgAnimated.vue'

export default {
    name: 'case',
    components: {
        CaseViewBaseLayout,
        CaseViewDoubleWithoutMargin,
        CaseViewDoubleWithMargin,
        CaseViewSingleImage,
        CaseViewSingleVideo,
        CaseViewDuoOffsetImage,
        CaseViewLargeText,
        CaseViewTrippleImage,
        CaseViewTestimony,
        CaseViewColors,
        SvgImage,
        SvgAnimated,
    },
    render: function(createElement) {
        /*
         * createElement() takes 3 arguments:
         *     tag-name:    What to render.
         *     props/attr:  An object with props/attr for the component in the first argument.
         *     'itself cb': Another renderFunction('s), that will get rendered in the <slot> of the first component.
         *
         * Here we create an Base Layout-component with some base props.
         * As the third argument the createElement function is called for each component that
         * should be rendered inside the slot of the Base Layout.
         *
         * At the moment only one level of components can be rendered from the json.
         * But technically you could make the json deeper and refactor these render functions to be recursive.
         * See https://medium.com/@harin76/generate-vue-js-components-from-a-json-javascript-dom-structure-a76534478d15
         */
        return createElement(
            'CaseViewBaseLayout', {
                props: {
                    id: this.currentCase.id
                }
            }, this.createRenderArray({
                function: createElement,
                array: this.allTheChildren
            })
        )
    },
    computed: mapState({
        currentCase(state) {
            return state.data.cases.find(key => key.info.url === state.currentCase)
        },
    }),
    watch: {
        currentCase() {
            this.$store.commit('SET_CURRENT_CASE', this.$route.params.url.toLowerCase())
        }
    },
    methods: {
        /*
         * Creates/returns an array of component-data depending on what data is specified in the data.json
         * Makes the page layout dynamic, because you can specify amount/order of components through the json
         */
        allTheChildren() {
            return this.currentCase.pageContent.map(component => {
                return {
                    name: component.componentName,
                    propsObj: {
                        props: component.props
                    }
                }
            })
        },
        /*
         * Creates/returns an array of functions, with component-data as it's arguments.
         * When this function is called from the main render function,
         * as the third argument, it act as a list of components to render.
         */
        createRenderArray({
            function: createElement,
            array: allTheChildren
        }) {
            return allTheChildren().map(component => createElement(component.name, component.propsObj))
        },
    },
    created() {
        this.$store.commit('SET_CURRENT_CASE', this.$route.params.url.toLowerCase())
    },
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

.case-page {
    z-index: 2;
    width: 100%;
}
</style>
